import React, { Fragment, useState, useEffect } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import numeral from 'numeral';
import { toInteger } from 'lodash';
import { withStyles } from '@material-ui/core/styles';

import Pager from 'src/utils/Pager';
import agm from '../../services/agm'


import {
    Tooltip,
    Icon,
    Avatar,
    Box,
    InputLabel,
    Select,
    MenuItem,
    makeStyles,
    Grid,
    Card,
    Table,
    Radio,
    TablePagination,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableContainer,
    DialogTitle,
    Divider,
    DialogContent,
    Dialog,
    colors,
    Typography,
    Button,
    TextField,
    InputAdornment,
    SvgIcon,
    FormControl,
    CardContent,
    Link,
    ListItemText,
    Checkbox
} from '@material-ui/core';

import { Search as SearchIcon } from 'react-feather';
import { FaClipboardList } from "react-icons/fa";

var Item = FaClipboardList;

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    },
    container: {
        maxHeight: 415,
        minHeight: 415
    }
}));

const visions = [
    { id: 2, name: 'Itens LPU pelo nome', refine: 2, label: 'Nome do Item LPU', history: 0, columns: [] },
    { id: 1, name: 'Itens LPU pelo código', refine: 1, label: 'Código do Item LPU', history: 0, columns: [] }
];

const defaultState = {
    loaded: false,
    pages: 1,
    page: 1,
    count: 0,
    rows: []
}

const defaultFilter = {
    pagina: 0,
    registros: 10,
    palavrachave: '',
    visao: visions[0],
    ativo: true
}

const ColorCheckbox = withStyles({
    root: {
        marginLeft: 0,
        color: colors.cyan[400],
        '&$checked': {
            color: colors.cyan[500],
        },
    },
    checked: {},
})((props) => <Checkbox color="default" {...props} />);


const Find = ({ open, closeFind, selectProduct, values, applications, region }) => {

    const classes = useStyles();

    const [filter, setFilter] = useState(defaultFilter);
    const [keyword, setKeyword] = useState('');
    const [query, setQuery] = useState(visions[0]);
    const [selected, setSelected] = useState(null);
    const [page, setPage] = useState(0);
    const [rows, setRows] = useState(10);
    const [resultset, setResultset] = useState(defaultState);
    const [labelApplications, setLabelApplications] = useState([]);
    const [applicationSelecteds, setApplicationSelecteds] = useState([]);

    const handleSelect = (item) => () => {
        setSelected(item);
    };

    const changeQuery = (event) => {
        setQuery(event.target.value);
        setPage(0);
        changeFilter(event.target.value, keyword, page, rows);
    }

    const changeKeyword = (event) => {
        setKeyword(event.target.value);
        setPage(0);
        changeFilter(query, event.target.value, page, rows);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
        changeFilter(query, keyword, newPage, rows);
    };

    const handleChangeRowsPerPage = (event) => {
        var rowsPerPage = parseInt(event.target.value, 10);
        setRows(rowsPerPage);
        setPage(0);
        changeFilter(query, keyword, page, rowsPerPage);
    };

    const changeApplications = (event) => {
        var appls = [0];
        for (let indexA = 0; indexA < applications.length; indexA++) {
            const elementA = applications[indexA];
            for (let indexB = 0; indexB < event.target.value.length; indexB++) {
                const elementB = event.target.value[indexB];
                if (elementA.nome == elementB) {
                    appls.push(elementA.id);
                }
            }
        }
        const value = {
            pagina: page,
            registros: rows,
            palavrachave: keyword,
            visao: query,
            ativo: true,
            aplicacoes: appls,
            regiao: region
        }
        setPage(0);
        setFilter(value);
        setApplicationSelecteds(appls);
        setLabelApplications(event.target.value);
        agm.post('/produtoslpu/historico', { filtro: value }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    const refreshItems = () => {
        var appls = [];
        var lbappls = [];
        for (let index = 0; index < applications.length; index++) {
            const element = applications[index];
            if (element.extra != 1) {
                appls.push(element.id);
                lbappls.push(element.nome);
            }
        }
        const value = {
            pagina: page,
            registros: rows,
            palavrachave: keyword,
            visao: query,
            ativo: true,
            aplicacoes: appls,
            regiao: region
        }
        setFilter(value);
        setApplicationSelecteds(appls);
        setLabelApplications(lbappls);
        agm.post('/produtoslpu/historico', { filtro: value }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / filter.registros)) + 1,
                    page: filter.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            console.error(error);
        })
    }

    useEffect(() => {
        if (!resultset.loaded) {
            setSelected(null);
            refreshItems();
        }
        return
    }, []);

    const changeFilter = (view, keyword, page, rows) => {
        const value = {
            pagina: page,
            registros: rows,
            palavrachave: keyword,
            visao: view,
            ativo: true,
            aplicacoes: applicationSelecteds,
            regiao: region
        }
        setFilter(value);
        agm.post('/produtoslpu/historico', { filtro: value }, {
        }).then((response) => {
            if (!response.data.error) {
                setResultset({
                    loaded: true,
                    pages: toInteger((response.data.count / value.registros)) + 1,
                    page: value.pagina,
                    count: response.data.count,
                    rows: response.data.rows
                });
            } else {
                setResultset(defaultState);
            }
        }).catch((error) => {
            console.error(error);
        })
    }


    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="xl" fullWidth >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Buscar por Produto LPU
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Box >
                        <Card>
                            <CardContent>

                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <Grid container spacing={1}>

                                            <Grid item
                                                md={2}
                                                xs={12}
                                            >
                                                <TextField
                                                    fullWidth
                                                    label="Região"
                                                    margin="none"
                                                    name="region"
                                                    id="region"
                                                    value={(region) ? region.nome : 'Desconhecida'}
                                                    variant="outlined"
                                                    inputProps={
                                                        { readOnly: true, }
                                                    }
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>


                                            <Grid item
                                                md={2}
                                                xs={12}>

                                                <FormControl variant="outlined" margin="none" fullWidth>
                                                    <InputLabel shrink htmlFor="query">Pesquisa</InputLabel>
                                                    <Select notched
                                                        required={true}
                                                        fullWidth={true}
                                                        label="Pesquisa"
                                                        variant="outlined"
                                                        id="query"
                                                        name="query"
                                                        value={query}
                                                        onChange={changeQuery}
                                                        inputProps={{
                                                            name: 'query',
                                                            id: 'query',
                                                        }}
                                                    >
                                                        {visions.map((view) => (
                                                            <MenuItem key={view.id} value={view}>{view.name}</MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item
                                                md={3}
                                                xs={12}
                                            >
                                                <TextField
                                                    fullWidth
                                                    margin="none"
                                                    disabled={!query.refine}
                                                    onChange={changeKeyword}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <SvgIcon
                                                                    fontSize="small"
                                                                    color="action"
                                                                >
                                                                    <SearchIcon />
                                                                </SvgIcon>
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    placeholder={"Refinar pesquisa por, " + query.label}
                                                    variant="outlined"
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            <Grid
                                                item
                                                md={5}
                                                xs={12}>
                                                <FormControl variant="outlined" fullWidth>
                                                    <InputLabel shrink htmlFor="labelApplications">Aplicações</InputLabel>
                                                    <Select notched
                                                        id="labelApplications"
                                                        multiple
                                                        value={labelApplications}
                                                        onChange={changeApplications}
                                                        fullWidth
                                                        label="Aplicações"
                                                        name="labelApplications"
                                                        variant="outlined"
                                                        renderValue={(selected) => selected.join(', ')}
                                                        inputProps={{
                                                            name: 'labelApplications',
                                                            id: 'labelApplications',
                                                        }}
                                                    >

                                                        {applications.map((item) => (
                                                            <MenuItem key={item.id} value={item.nome} label={item.nome} >
                                                                <ColorCheckbox checked={labelApplications.indexOf(item.nome) > -1} />
                                                                <ListItemText primary={item.nome} ></ListItemText>
                                                            </MenuItem>
                                                        ))}

                                                    </Select>
                                                </FormControl>
                                            </Grid>


                                        </Grid>

                                    </Grid>

                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >
                                        <Grid container
                                            fullWidth
                                            direction="row"
                                            justify="flex-start"
                                            alignItems="flex-start"
                                        >

                                            <Grid item
                                                md="auto"
                                                xs="auto"
                                            >

                                                <TablePagination
                                                    component="div"
                                                    className={classes.pager}
                                                    page={page}
                                                    rowsPerPage={rows}
                                                    count={resultset.count}
                                                    labelRowsPerPage="Linhas por página"
                                                    labelDisplayedRows={({ from, to, count }) => `Encontrados: ${count}, Apresentando de: ${from} a ${to}`}
                                                    onChangePage={handleChangePage}
                                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                                    ActionsComponent={Pager}
                                                    SelectProps={{
                                                        inputProps: { 'aria-label': 'Linhas por página' },
                                                        native: false
                                                    }}
                                                />

                                            </Grid>

                                        </Grid>

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                        <br></br>

                        <Card>
                            <CardContent>


                                <Grid
                                    container
                                    spacing={2}
                                    xs="auto"
                                >
                                    <Grid item
                                        md={12}
                                        xs={12}
                                    >

                                        <TableContainer component={PerfectScrollbar} className={classes.container}>

                                            <Table stickyHeader size="small" aria-label="a dense table" >
                                                <TableHead>
                                                    <TableRow>

                                                        <TableCell>
                                                            Código LPU
                                                        </TableCell>

                                                        <TableCell>
                                                            Nome
                                                        </TableCell>

                                                        <TableCell>
                                                            Categoria
                                                        </TableCell>

                                                        <TableCell>
                                                            Unidade
                                                        </TableCell>

                                                        <TableCell>
                                                            Valor Material
                                                        </TableCell>

                                                        <TableCell>
                                                            Valor Mão Obra
                                                        </TableCell>

                                                        <TableCell>

                                                        </TableCell>

                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {resultset.rows.map((item) => (
                                                        <TableRow
                                                            hover
                                                            key={item.id}
                                                            onClick={() => { selectProduct(values, item) }}
                                                        >
                                                            <TableCell>
                                                                <Box
                                                                    alignItems="center"
                                                                    display="flex"
                                                                    component={Link}
                                                                    
                                                                >
                                                                    <Avatar
                                                                        className={classes.avatar}
                                                                    >
                                                                        {<Icon component={Item} style={{ color: colors.cyan[500] }} ></Icon>}
                                                                    </Avatar>
                                                                    {(item.codigo) ? item.codigo : '...'}
                                                                </Box>
                                                            </TableCell>

                                                            <TableCell width={840}>
                                                                <Typography variant="body" noWrap={false} >
                                                                    {item.nome}
                                                                </Typography>
                                                            </TableCell>

                                                            <TableCell>
                                                                {(item.aplicacao) ? item.aplicacao.nome : "Não Informado"}
                                                            </TableCell>

                                                            <TableCell >
                                                                {(item.unidade) ? item.unidade.nome : "Não Informado"}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(item.valor) ? numeral(item.valor).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell>
                                                                {(item.instalacao) ? numeral(item.instalacao).format('0.00').replace('.', ',') : '0,00'}
                                                            </TableCell>

                                                            <TableCell>
                                                                <Tooltip title="Selecionar produto">
                                                                    <Radio id={item.id}
                                                                        value={item.id}
                                                                        checked={(selected) ? selected.id === item.id : false}
                                                                        onChange={handleSelect(item)} />
                                                                </Tooltip>
                                                            </TableCell>
                                                        </TableRow>
                                                    ))
                                                    }

                                                    {(resultset.rows.length == 0) ? (
                                                        <TableRow  >
                                                            <TableCell colSpan={14} align="center" >
                                                                Nenhum Produto Foi Encontrado.
                                                            </TableCell>
                                                        </TableRow>
                                                    ) : ('')}

                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                    </Grid>

                                </Grid>
                            </CardContent>
                        </Card>

                    </Box>

                    <Divider />

                    <Box my={1}>
                        <Grid container
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                            spacing={1}  >
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { selectProduct(values, selected) }}>
                                    Adicionar
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    color="secondary"
                                    size="small"
                                    variant="contained"
                                    onClick={() => { closeFind() }}>
                                    Cancelar
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>

                </DialogContent>

            </Dialog>

        </Fragment >
    );
};

export default Find;
